export class NumberParser {
  _locale: Intl.LocalesArgument & string;
  _group: RegExp;
  _decimal: RegExp;
  _numeral: RegExp;
  _index: (d: any) => string;

  constructor(locale: Intl.LocalesArgument & string) {
    this._locale = locale;
    const parts = new Intl.NumberFormat(this._locale).formatToParts(12345.6);
    const numerals = [...new Intl.NumberFormat(this._locale, { useGrouping: false }).format(9876543210)].reverse();
    const index = new Map(numerals.map((d, i) => [d, i]));

    this._group = new RegExp(`[${parts.find((d) => d.type === "group")?.value}]`, "g");
    this._decimal = new RegExp(`[${parts.find((d) => d.type === "decimal")?.value}]`);
    this._numeral = new RegExp(`[${numerals.join("")}]`, "g");
    this._index = (d) => `${index.get(d)}`;
  }
  parseLocaleStringToNumber(inputValue: unknown): number {
    if (!inputValue || (typeof inputValue != "number" && typeof inputValue != "string")) return NaN;
    if (typeof inputValue == "number") return inputValue;
    const _string = inputValue.trim().replace(this._group, "").replace(this._decimal, ".").replace(this._numeral, this._index);
    return _string ? +_string : NaN;
  }
  parseLocaleStringToIndepentendNumberString(inputValue: unknown): string {
    if (!inputValue || typeof inputValue != "string") return "";
    const _string = inputValue.trim().replace(this._group, "").replace(this._decimal, ".").replace(this._numeral, this._index);
    return _string ? _string : "";
  }
  parseNumberToLocaleString(n: number | null | undefined, numberFormatOptions: Intl.NumberFormatOptions = {}): string {
    if (typeof n != "number") return "";
    const _string = new Intl.NumberFormat(this._locale, Object.assign({ useGrouping: false, maximumFractionDigits: 20 }, numberFormatOptions)).format(n);
    return _string;
  }
}
